import { render, staticRenderFns } from "./RecommendedModal.vue?vue&type=template&id=4470bd3e&"
import script from "./RecommendedModal.vue?vue&type=script&lang=js&"
export * from "./RecommendedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports